import { StateManager } from '../core/StateManager';
import { DRIVE_PROFILES } from '../config/profiles';
import { escapeHtml } from '../utils/sanitize';

export class Recommendations {
  private unsubscribers: (() => void)[] = [];
  private lastHtml = '';

  constructor(
    private state: StateManager,
    private container: HTMLElement,
  ) {
    const updateFn = (): void => this.update();
    this.unsubscribers.push(state.subscribe('looseTerminal', updateFn));
    this.unsubscribers.push(state.subscribe('cloggedHeatsink', updateFn));
    this.unsubscribers.push(state.subscribe('daysOffline', updateFn));
    this.unsubscribers.push(state.subscribe('selectedProfileKey', updateFn));
    this.update();
  }

  private update(): void {
    const html = this.generateHtml();
    if (html !== this.lastHtml) {
      this.container.innerHTML = html;
      this.lastHtml = html;
    }
  }

  private generateHtml(): string {
    const timeStr = new Date().toLocaleTimeString();
    const profileKey = this.state.get('selectedProfileKey');
    const profile = DRIVE_PROFILES[profileKey];
    const profileName = profile ? escapeHtml(profile.name) : 'Inversor';
    const looseTerminal = this.state.get('looseTerminal');
    const cloggedHeatsink = this.state.get('cloggedHeatsink');
    const daysOffline = this.state.get('daysOffline');

    let html = '';

    if (looseTerminal) {
      html += `
        <div class="rec-card rec-danger">
          <div class="rec-header">
            <span class="rec-title-danger">Conexão Inadequada no DC Link</span>
            <span class="rec-timestamp">${timeStr}</span>
          </div>
          <div class="rec-body">Ondulação de alta frequência (Ripple) detectada no barramento. Risco de fadiga nos capacitores.</div>
          <div class="rec-action">Ação: Torquear bornes de potência conforme manual do ${profileName}.</div>
        </div>`;
    }

    if (cloggedHeatsink) {
      html += `
        <div class="rec-card rec-warn">
          <div class="rec-header">
            <span class="rec-title-warn">Restrição Térmica do Dissipador</span>
            <span class="rec-timestamp">${timeStr}</span>
          </div>
          <div class="rec-body">Gradiente de temperatura elevado. Eficiência de exaustão reduzida.</div>
          <div class="rec-action">Ação: Realizar limpeza técnica do canalete de ventilação.</div>
        </div>`;
    }

    if (daysOffline > 180) {
      html += `
        <div class="rec-card rec-warn">
          <div class="rec-header">
            <span class="rec-title-warn">Despassivação de Capacitores</span>
            <span class="rec-timestamp">${timeStr}</span>
          </div>
          <div class="rec-body">Inversor inativo há mais de 180 dias. A energização direta sem reforming pode danificar o retificador.</div>
          <div class="rec-action">Ação: Aplicar protocolo de Reforming via fonte CC regulada.</div>
        </div>`;
    }

    if (!html) {
      html = `
        <div class="rec-card rec-ok">
          <div class="rec-header">
            <span class="rec-title-ok">Status de Operação Perfeito</span>
            <span class="rec-timestamp">${timeStr}</span>
          </div>
          <div class="rec-body">Parâmetros elétricos e térmicos dentro da curva nominal do ${profileName}.</div>
        </div>`;
    }

    return html;
  }

  destroy(): void {
    this.unsubscribers.forEach((fn) => fn());
    this.unsubscribers = [];
  }
}
